"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureTogglesContext = void 0;
var _react = require("react");
const featureTogglesContext = exports.featureTogglesContext = /*#__PURE__*/(0, _react.createContext)([]);
